import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastService } from '@umss/shared/ui';
@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'business';

  constructor(
    private toastService: ToastService,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.toastService.registerContainer(this.vcr);
  }
}
